const assetBaseUrl = (process.env.VUE_APP_ASSET_BASE_URL || '').replace(/\/$/, '');
const assetProvider = (process.env.VUE_APP_ASSET_PROVIDER || '').toLowerCase();
const cosDomain = process.env.VUE_APP_COS_DOMAIN || '';

const isAbsoluteUrl = (url) => /^https?:\/\//i.test(url);
const isSignedCosUrl = (url) => /[?&](q-sign-algorithm|X-Amz-Signature)=/i.test(url);

const getAssetUrl = (path) => {
  if (!path) return path;
  if (isAbsoluteUrl(path)) return path;
  if (!assetBaseUrl) return path;
  const normalizedPath = path.replace(/^\//, '');
  return `${assetBaseUrl}/${normalizedPath}`;
};

const shouldUseCosOptimization = (url) => {
  if (!url) return false;
  if (isSignedCosUrl(url)) return false;
  if (assetProvider === 'minio') return false;
  // 同源 COS 代理：缩略参数由后端转发给 COS
  if (url.startsWith('/api/cos-asset/')) return true;
  if (assetProvider === 'cos') return true;
  if (cosDomain && url.includes(cosDomain)) return true;
  return url.includes('tencentcos.cn') || url.includes('cos.');
};

const applyCosOptimization = (url, width, height, quality) => {
  if (!shouldUseCosOptimization(url)) return url;
  const separator = url.includes('?') ? '&' : '?';
  return `${url}${separator}imageMogr2/thumbnail/${width}x${height}/quality/${quality}`;
};

export {
  applyCosOptimization,
  getAssetUrl,
  isSignedCosUrl,
  shouldUseCosOptimization
};
